import { render, staticRenderFns } from "./CannedMessageHelper.vue?vue&type=template&id=56c22b0f&scoped=true"
import script from "./CannedMessageHelper.vue?vue&type=script&lang=js"
export * from "./CannedMessageHelper.vue?vue&type=script&lang=js"
import style0 from "./CannedMessageHelper.vue?vue&type=style&index=0&id=56c22b0f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c22b0f",
  null
  
)

export default component.exports